import { inArray } from '../../utils/fns';
import { PATH } from '../../types/router';

const allowedForInfo = inArray([PATH.INFO, PATH.UNIVERSAL]);
const resolveMovieEnd = (historyArray) => {
  const allowInfo = historyArray.find((history) => allowedForInfo(history.path));

  return allowInfo && { path: PATH.INFO };
};

export default resolveMovieEnd;
